import styled from 'styled-components';
import { styles } from '../../../../consts';

const { progressBarFill, fontMBank, errorColor } = styles;

const setVisible = ({ isVisible }: { isVisible: boolean }) => (isVisible ? 'visible' : 'hidden');

export const Container = styled.div`
  width: 85%;
  margin: 0.5rem auto 0.5rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin: 1.5rem auto;
  }
`;

export const ErrorMessage = styled.div<{ isVisible: boolean }>`
  color: ${errorColor};
  font-size: 0.75rem;
  margin: 0.5rem auto 0.5rem;
  visibility: ${setVisible};
`;

export const Description = styled.div`
  width: 5rem;
  height: 1.35rem;
  padding-top: 0.25rem;
  font-family: ${fontMBank};
  font-size: 0.436875rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${progressBarFill};
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
`;
